import { render } from "./CrearEntradaFromRecepcionPage.vue?vue&type=template&id=0c3ca166&scoped=true"
import script from "./CrearEntradaFromRecepcionPage.vue?vue&type=script&lang=js"
export * from "./CrearEntradaFromRecepcionPage.vue?vue&type=script&lang=js"

import "./CrearEntradaFromRecepcionPage.vue?vue&type=style&index=0&id=0c3ca166&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3ca166"]])

export default __exports__